import * as React from "react";
import {
  Alert,
  Form,
  FormButton,
  FormField,
  FormInput,
  Flex,
  Provider,
  Text,
} from "@fluentui/react-northstar";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTeams } from "msteams-react-base-component";
import { app, authentication, dialog } from "@microsoft/teams-js";
import * as authService from "../services/auth.service";
import * as promoService from "../services/promotion.service";
import {
  LogoComponent,
  MSLogoComponent,
  InfoComponent,
  HelpComponent,
} from "./common/logo";
import { LoaderExample } from "./common/loader";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Config } from "../../server-config";

/**
 * Implementation of the Recognize Task Module page
 */

app.initialize();

export const AppcodeComponent = () => {
  const history = useHistory();
  const initialAppcodeState = {
    appcode: "",
  };

  const [{ inTeams, theme }] = useTeams();
  const [formAppcode, setAppcode] = useState(initialAppcodeState);
  const [domain, setDomain] = useState("");
  const [tenantid, setTenantid] = useState("");
  const [supportEmail, setSupportEmail] = useState("biwrecognitionapp@biworldwide.com");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [alert, showAlert] = useState(false);
  const { t, i18n } = useTranslation();
  const [hide, setHide] = useState(true);
  const [inc, setInc] = useState(0);
  const [tinc, setTInc] = useState(0);

  useEffect(() => {
    if (inTeams === true) {
      app.notifySuccess();
    }
    if (window.location.href.includes("?lang")) {
      const language = window.location.href.split("?lang=")[1].split("&")[0];
      i18n.changeLanguage(language);
    } else if (window.location.href.includes("&lang")) {
      const language = window.location.href.split("&lang=")[1].split("&")[0];
      i18n.changeLanguage(language);
    }
    if (window.location.href.includes("&userDomain")) {
      const currentDomain = window.location.href.split("&userDomain=")[1].split("&")[0];
      setDomain(currentDomain);
    }
    if (window.location.href.includes("&tId")) {
      const tId = window.location.href.split("&tId=")[1].split("&")[0];
      setTInc(tinc => tinc + 1);
      tenantBypass(tId, tinc);
    }
  }, [inTeams]);

  const appBypass = async (appcode, i) => {
    if (i === 0) {
      authService.getInstanceUrl(appcode).then((response) => {
        if (
          response.data.appProperties.host &&
          response.data.appProperties.context
        ) {
          showAlert(false);
          setLoading(false);
          localStorage.setItem("host", response.data.appProperties.host);
          localStorage.setItem("context", response.data.appProperties.context);
          localStorage.setItem("tenantId", appcode);
          getSsoConfiguration();
        }
        else if (response.data.appProperties.projectnotfoundforAppCode) {
          showAlert(false);
          setLoading(false);
          setHide(false);
        }
      });
    }
  };
  const tenantBypass = async (appcode, i) => {
    if (i === 0) {
      authService.getInstanceUrl(appcode).then((response) => {
        if (
          response.data.appProperties.host &&
          response.data.appProperties.context
        ) {
          showAlert(false);
          setLoading(false);
          localStorage.setItem("host", response.data.appProperties.host);
          localStorage.setItem("context", response.data.appProperties.context);
          localStorage.setItem("tenantId", appcode);
          getSsoConfiguration();
        }
        else if (response.data.appProperties.projectnotfoundforAppCode) {
          showAlert(false);
          setLoading(false);
          const appcode = window.location.href.split("&appcode=")[1].split("&")[0];
          setInc(inc => inc + 1);
          appBypass(appcode, inc);
        }
      });
    }
  };

  useEffect(() => {
    if (domain !== "") {
      fetchSupportEmail(domain);
    }
  }, [domain]);

  const handleAppcodeState = (event) => {
    const { name, value } = event.target;
    setAppcode({ ...formAppcode, [name]: value });
  };

  const dismissAlerts = () => {
    showAlert(false);
  };

  useEffect(() => {
    const textValues = _.values(formAppcode);
    const data = textValues.filter((item) => item);
    data.length === 1 ? setDisable(false) : setDisable(true);
  }, [formAppcode]);
  // tslint:disable: no-shadowed-variable
  const fetchSupportEmail = async (domain) => {
    const emailData = await promoService.getSupportEmail(domain);
    const email = emailData && emailData.appProperties && emailData.appProperties.contactUSEmail !== "null" ? emailData.appProperties.contactUSEmail : "biwrecognitionapp@biworldwide.com";
    setSupportEmail(email);
  };

  const getInstanceUrl = () => {
    setLoading(true);
    setDisable(true);
    authService.getInstanceUrl(formAppcode.appcode).then((response) => {
      if (
        response.data.appProperties.host &&
        response.data.appProperties.context
      ) {
        showAlert(false);
        setLoading(false);
        localStorage.setItem("host", response.data.appProperties.host);
        localStorage.setItem("context", response.data.appProperties.context);
        localStorage.setItem("appcode", formAppcode.appcode);
        getSsoConfiguration();
      } else if (response.data.appProperties.projectnotfoundforAppCode) {
        showAlert(true);
        setLoading(false);
        setHide(false);
      }
    });
  };

  const getSsoConfiguration = async () => {
    authService.getSsoConfiguration().then((response) => {
      if (response.data.ssoenabled) {
        if (window.location.href.includes("botlogin")) {
          authentication.authenticate({
            url: `${window.location.origin}/sso-authenticate-start?ssoUrl=${response.data.ssoUrl}`,
            width: 500,
            height: 600,
          }).then((result) => {
            const data = JSON.parse(result);
            localStorage.setItem("appToken", data.token);
            dialog.url.submit({              
                token: data.token,
                host: localStorage.getItem("host"),
                locUrl: window.location.href,
                context: localStorage.getItem("context"),
                appCode: localStorage.getItem("appcode"),
            }, Config.MICROSOFT_APP_ID());
          })
          .catch((error) => {
            console.error("Authentication failed:", error);
          });
        } else {
          window.location.assign(
            `${response.data.ssoUrl}`
          );
        }
      } else {
        const addData = window.location.href.includes("botlogin") && "botlogin";
        history.push(`/login?${addData}`);
      }
    });
  };



  return (

    <Provider theme={theme} className="loginProvider" onClick={dismissAlerts}>
      {hide ? <div>{t("Loading.header")}</div> :
        <Flex fill={true} className="appCodeWrapper" column={true}>
          {loading && <LoaderExample />}
          {alert && (
            <Alert
              danger
              content={t("Appcode.ErrorRequired")}
              onVisibleChange={() => {
                showAlert(!alert);
              }}
              dismissible
              visible={alert}
              dismissAction={{
                "aria-label": "close",
              }}
              className="logonAlert"
            />
          )}
          <Flex.Item align="center">
            <LogoComponent />
          </Flex.Item>
          <Flex.Item>
            <Form className="appForm">
              <FormField>
                <Text
                  className="bit_text_24 bit_text_bold loginHeader"
                  content={t("Appcode.Login")}
                />
                <FormInput
                  placeholder={t("Appcode.AppCode")}
                  name="appcode"
                  id="app-code"
                  fluid
                  required
                  showSuccessIndicator={false}
                  onChange={handleAppcodeState}
                  className={`${"biw_input"}`}
                  styles={{ backgroundColor: "#ffffff" }}
                  autoFocus
                />
              </FormField>
              <FormButton
                fluid={true}
                onClick={getInstanceUrl}
                content={t("Appcode.Submit")}
                key="submit"
                primary
                disabled={disable ? true : false}
              />
            </Form>
          </Flex.Item>
          {/* <Flex.Item>
          <InfoComponent content={t("Appcode.ContactAdministrator")} />
        </Flex.Item> */}
          <Flex.Item>
            <HelpComponent
              helpContent={t("Appcode.WantToKnowMore")}
              supportEmail={supportEmail}
              emailUs={t("Appcode.EmailUs")}
              visitUs={t("Appcode.VisitUs")}
              content={t("Appcode.CompanySpecificMessage") + "   " + t("Appcode.ContactAdministratorMessage")} />
          </Flex.Item>
        </Flex>
      }
    </Provider>
  );
};
